<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :close-on-click-modal="false"
      :visible.sync="innerVisible"
      :title="$t('CargoMsg.Cargo_PushLog')"
      @close="innerVisible=false"
    >
      <div class="app-main-inner-row">
        <el-form :inline="true" label-position="left" @submit.native.prevent>
          <el-form-item :label="$t('CargoMsg.Cargo_InvoiceTitle')" class="el-form-item-filter">
            <el-input v-model="txtFilter" @input="filterChangeHandler" @keyup.enter.native="filterChangeHandler" />
          </el-form-item>
        </el-form>
      </div>
      <div class="app-main-inner-row row-grid">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          min-height="320px"
        />
      </div>
      <div slot="footer">
        <el-button type="primary" @click="confirmHandler">{{ $t('common.btn.confirm') }}</el-button>
        <el-button type="primary" @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { getInvoiceTitleListFunc } from '@/api/act/preliminaryEstimate'
export default {
  name: 'InvoiceTitle',
  props: {
    visible: { type: Boolean, required: true }
  },
  data() {
    return {
      loading: false,
      innerVisible: false,
      SystemConstants,
      gridOptions: {
        rowSelection: 'multiple',
        suppressContextMenu: true,
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        }
      },
      gridParams: {},
      gridApi: {},
      rowData: [],
      sourceRowData: [],
      txtFilter: ''
    }
  },
  computed: {
    columnDefs() {
      return [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_InvoiceTitle'),
          field: 'name',
          width: 180,
          editable: false
        }
      ]
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.toQuery()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
        this.sourceRowData = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.queryCodeMapping()
      this.innerVisible = true
    }
  },
  methods: {
    queryCodeMapping() {
      const filterJson = {}
      filterJson.branchId = this.$store.getters.currentOfficeId
      filterJson.type = SystemConstants.MAPPING_INVOICE_TITLE.code
      filterJson.sendingPlatform = SystemConstants.SENDING_SHARED_CENTER.code
      getInvoiceTitleListFunc(filterJson).then(resp => {
        this.rowData = resp.data
        this.sourceRowData = resp.data
      })
      if (this.gridOptions.api) {
        this.gridOptions.api.clearFocusedCell()
      }
    },
    invoiceTitleFilter(title) {
      const typedText = this.txtFilter.trim()
      if (title.name && title.name.toLowerCase().indexOf(typedText.toLowerCase()) >= 0) {
        return true
      }
      return false
    },
    filterChangeHandler() {
      this.rowData = this.sourceRowData.filter(row => this.invoiceTitleFilter(row))
      this.gridOptions.api.refreshCells({ force: true })
    },
    // 确认
    confirmHandler() {
      const rows = this.gridOptions.api.getSelectedRows()
      if (!rows || rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseChooseData'))
        return
      }
      const list = []
      for (const row of rows) {
        const mapping = {}
        mapping.uuid = ''
        mapping.type = SystemConstants.MAPPING_INVOICE_TITLE.code
        mapping.condition1 = ''
        mapping.sourceValue = row.name
        mapping.targetValue = ''
        mapping.remarks = ''
        mapping.officeId = this.$store.getters.currentOfficeId
        mapping.sendingPlatform = 'sharedCenter'
        mapping.sendingPlatformList = ['sharedCenter']
        list.push(mapping)
      }
      this.$emit('enter', list)
      this.innerVisible = false
    }
  }
}
</script>

<style lang="scss">
.el-loading-mask.is-fullscreen {
  z-index: 999999 !important;
}
</style>

